export var HttpRequestType;
(function (HttpRequestType) {
    let StatusCode;
    (function (StatusCode) {
        // 成功
        StatusCode[StatusCode["Ok"] = 200] = "Ok";
        StatusCode[StatusCode["Created"] = 201] = "Created";
        StatusCode[StatusCode["NotModified"] = 304] = "NotModified";
        // エラー(クライアント側の問題)
        StatusCode[StatusCode["BadRequest"] = 400] = "BadRequest";
        StatusCode[StatusCode["UnAuthorized"] = 401] = "UnAuthorized";
        StatusCode[StatusCode["Forbidden"] = 403] = "Forbidden";
        StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
        StatusCode[StatusCode["Conflict"] = 409] = "Conflict";
        StatusCode[StatusCode["TooManyRequests"] = 429] = "TooManyRequests";
        // エラー(サーバー側の問題)
        StatusCode[StatusCode["InternalServerError"] = 500] = "InternalServerError";
        StatusCode[StatusCode["BadGateway"] = 502] = "BadGateway";
        StatusCode[StatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
        StatusCode[StatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    })(StatusCode = HttpRequestType.StatusCode || (HttpRequestType.StatusCode = {}));
    /**
     * メッセージを表示するタイプ
     */
    let DisplayMessageType;
    (function (DisplayMessageType) {
        DisplayMessageType[DisplayMessageType["None"] = 0] = "None";
        DisplayMessageType[DisplayMessageType["ErrorOnly"] = 1] = "ErrorOnly";
        DisplayMessageType[DisplayMessageType["All"] = 2] = "All";
    })(DisplayMessageType = HttpRequestType.DisplayMessageType || (HttpRequestType.DisplayMessageType = {}));
    /**
     * Http のメソッドの種類(使用するもののみ)
     */
    let MethodType;
    (function (MethodType) {
        MethodType["Get"] = "GET";
        MethodType["Post"] = "POST";
        MethodType["Put"] = "PUT";
        MethodType["Delete"] = "DELETE";
    })(MethodType = HttpRequestType.MethodType || (HttpRequestType.MethodType = {}));
    /**
     * 戻る情報のタイプ
     */
    let ResponseType;
    (function (ResponseType) {
        ResponseType["Json"] = "json";
        ResponseType["Text"] = "text";
    })(ResponseType = HttpRequestType.ResponseType || (HttpRequestType.ResponseType = {}));
    class ResponseResult {
    }
    HttpRequestType.ResponseResult = ResponseResult;
})(HttpRequestType || (HttpRequestType = {}));
